const Card = ({ children, className, ...rest }) => (
    <div
        className={`bg-white shadow-md rounded px-6 py-8 ${className}`}
        {...rest}>
        {children}
    </div>
);

export default Card;